import React from "react";
export const PoliticasCambioDevoluciones = () => (
    <>
        <div className="texto-container">
            Lorem ipsum dolor sit amet consectetur. Sed elit aliquet feugiat
            bibendum vel ut massa. Pellentesque sed donec erat tempus arcu. Lectus
            cum commodo consequat justo quam vel congue fermentum. Sit nunc amet
            tincidunt non nullam pharetra. Imperdiet duis urna enim diam lacus
            fermentum ut tristique ullamcorper. Aliquam arcu nunc purus ipsum erat
            facilisi. Malesuada consequat donec sed phasellus aenean aenean. Nulla
            ullamcorper elit integer id feugiat. Ornare semper platea aliquam
            viverra scelerisque. Viverra elementum purus egestas donec vel proin sed
            consequat lectus. Fames eget ullamcorper eu pellentesque porttitor eros
            lectus neque. In volutpat nisi quisque facilisi parturient. Non leo sit
            sapien proin lectus. Quam nunc neque eleifend nisi pulvinar cras
            senectus arcu. Volutpat a sit ut adipiscing. Dignissim eget aliquam
            ornare porttitor du suada suspendisse proin tempus duis. Fames eget
            ullamcorper eu pellentesque porttitor eros lectus neque. In volutpat
            nisi quisque facilisi parturient. Non leo sit sapien proin lectus. Quam
            nunc neque eleifend nisi pulvinar cras senectus arcu. Volutpat a sit ut
            adipiscing. Dignissim eget aliquam ornare porttitor du suada suspendisse
            proin tempus duis. Fames eget ullamcorper eu pellentesque porttitor eros
            lectus neque. In volutpat nisi quisque facilisi parturient. Non leo sit
            sapien proin lectus. Quam nunc neque eleifend nisi pulvinar cras
            senectus arcu. Volutpat a sit ut adipiscing. Dignissim eget aliquam
            ornare porttitor du suada suspendisse proin tempus duis. Fames eget
            ullamcorper eu pellentesque porttitor eros lectus neque. In volutpat
            nisi quisque facilisi parturient.
        </div>
    </>
);